export default "__VITE_ASSET__LsUbOHpV__"